import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function PlanningDraftsAPI(): BringozApi {
  return {
    base: `/planning/projects/{projectId}/drafts`,
    infiniteScroll: {
      address: `/planning/projects/{projectId}/drafts`,
      cmd: 'GET'
    },
    actions: {
      updateDraft: {
        address: '{draftId}',
        cmd: 'POST',
        updateable: false
      },
      duplicateDraft: {
        address: '{draftId}/duplicate',
        cmd: 'POST',
        updateable: false
      },
      getDraftJobs: {
        address: '{draftId}/jobs',
        cmd: 'GET',
        updateable: true
      },
      getDraftResources: {
        address: '{draftId}/resources',
        cmd: 'GET',
        updateable: true
      },
      createDraftResources: {
        address: '{draftId}/resources',
        cmd: 'PUT',
        updateable: true
      },
      getDraftRoutes: {
        address: '{draftId}/routes',
        cmd: 'GET',
        updateable: false
      },
      updateDraftJobs: {
        address: '{draftId}/jobs',
        cmd: 'POST',
        updateable: false
      },
      updateResourceSequence: {
        address: '{draftId}/routes/groups/{routeGroupId}/sequence',
        cmd: 'POST',
        updateable: false
      },
      updateDraftResources: {
        address: '{draftId}/resources',
        cmd: 'POST',
        updateable: false
      },
      swapRouteResources: {
        address: '{draftId}/routes/swapRouteResources',
        cmd: 'POST',
        updateable: true
      },
      changeRouteResource: {
        address: '{draftId}/routes/{routeId}/changeResource',
        cmd: 'POST',
        updateable: true
      },
      updateRoutePickingTimeOffset: {
        address: '{draftId}/routes/{routeId}/editPickingTime',
        cmd: 'POST',
        updateable: true
      },
      updateRoutesPickingTime: {
        address: '{draftId}/routes/editPickingTime',
        cmd: 'POST',
        updateable: true
      },
      updateRouteName: {
        address: '{draftId}/routes/{routeId}/setName',
        cmd: 'POST',
        updateable: true
      },
      updateRouteColor: {
        address: '{draftId}/routes/{routeId}/setColor',
        cmd: 'POST',
        updateable: true
      },
      updateRouteFeedback: {
        address: '{draftId}/routes/{routeId}/feedback',
        cmd: 'POST',
        updateable: false
      },
      updateAddress: {
        address: '{draftId}/address/{id}',
        cmd: 'POST',
        updateable: true
      },
      updateDraftResource: {
        address: '{draftId}/resources/{resourceId}',
        cmd: 'POST',
        updateable: false
      },
      splitJobByPackages: {
        address: '{draftId}/jobs/{draftJobId}/split/package',
        cmd: 'POST',
        updateable: false
      },
      splitAndAssignJobByPackages: {
        address: '{draftId}/jobs/{draftJobId}/split/packages/assign',
        cmd: 'POST',
        updateable: false
      },
      splitJobByLocation: {
        address: '{draftId}/jobs/{draftJobId}/split/location',
        cmd: 'POST',
        updateable: false
      },
      getJobSplitSuggestions: {
        address: '{draftId}/jobs/suggestions/{suggestionId}',
        cmd: 'GET',
        updateable: false
      },
      reverseJobSplit: {
        address: '{draftId}/jobs/suggestions/{splitSuggestionId}/split/undo',
        cmd: 'POST',
        updateable: false
      },
      generateJobSplitSuggestions: {
        address: '{draftId}/jobs/suggestions/generate',
        cmd: 'GET',
        updateable: false
      },
      bulkJobSplit: {
        address: '{draftId}/jobs/suggestions/bulk',
        cmd: 'PUT',
        updateable: false
      },
      generateRecommendations: {
        address: '{draftId}/recommendation/generate',
        cmd: 'GET',
        updateable: false
      },
      addClusteringAreaToDraft: {
        address: '{draftId}/actions/addArea',
        cmd: 'POST',
        updateable: false
      },
      removeClusteringAreaFromDraft: {
        address: '{draftId}/actions/removeClusteringArea',
        cmd: 'POST',
        updateable: false
      },
      addJobsToPlanningRoute: {
        address: '{draftId}/routes/{routeId}/jobs',
        cmd: 'POST',
        updateable: false
      },
      assignAgent: {
        address: '{draftId}/routes/assignAgent',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}

angular
  .module('bringoz.admin.planning')
  .service('PlanningDraftsAPI', PlanningDraftsAPI);
